import ModuleTranslations from "./ModuleTranslations";
import { getTranslatedDefinition } from "../../utils";
import { BASE_URL } from "../../../request";
import SortDirection from "react-virtualized/dist/commonjs/Table/SortDirection";
import { INVOICE_TYPE, RESTRICTION_TYPE } from "../../../Common/constants";
import { autocompleteValidator } from "../../../globalVariables";
import React from "react";

const ModuleDefinition = {
  name: "Contracts",
  entityName: "contracts",
  restConfig: {
    baseURL: `${BASE_URL}`,
    dataField: "content",
    create: {
      url: () => "api/contracts",
      method: "post",
    },
    fetch: {
      url: ({ id }) => `api/contracts${id ? "/" + id : "?size=10000"}`,
      method: "get",
    },
    update: {
      url: ({ id }) => `api/contracts/${id}`,
      method: "put",
    },
    delete: {
      url: ({ id }) => `api/contracts/${id}`,
      method: "delete",
    },
  },
  entities: [],
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section
  translation: {
    translated: true,
    fieldName: "translations",
    displayName: "translations",
    widget: "translations",
    entityProperty: "translations",
  },
  allowClone: false,
  allowDelete: false,
  allowExport: true,
  exportFileName: "crm_contracts_export",
  sorting: {
    property: "property",
    sortable: true,
    sortDirection: SortDirection.ASC,
  },
  reorder: false,
  showTotalRecords: true,
  filterFields: [
    "client",
    "status",
    "property",
    "group",
    "partner",
    "service",
    "rule",
    "discount",
    "currencyContract",
    "invoicePartner",
    ["created", "daterange"],
    ["updated", "daterange"],
    ["start", "daterange"],
    ["end", "daterange"],
  ],
  fields: {
    list: [
      {
        fieldName: "id",
        displayName: "Id",
        width: 100,
      },
      {
        fieldName: "client",
        displayName: "Cli",
        width: 150,
      },
      {
        fieldName: "idMyS",
        displayName: "id_MyS",
        width: 100,
      },
      {
        fieldName: "property",
        displayName: "Property",
        width: 190,
      },
      {
        fieldName: "group",
        displayName: "Grupo",
        width: 80,
      },
      {
        fieldName: "partner",
        displayName: "Partner",
        width: 100,
        visible: ({ userInfo }) => userInfo.isWitAdmin,
      },
      {
        fieldName: "service",
        displayName: "Service",
        width: 80,
      },
      {
        fieldName: "rule",
        displayName: "$Criteria",
        width: 90,
      },
      {
        fieldName: "value",
        displayName: "$Value",
        width: 70,
      },
      {
        fieldName: "minValue",
        displayName: "$Min.Mes",
        width: 80,
      },
      {
        fieldName: "net",
        displayName: "$Net",
        width: 70,
      },
      {
        fieldName: "units",
        displayName: "$Units",
        width: 70,
      },
      {
        fieldName: "discount",
        displayName: "Descuento",
        width: 100,
      },
      {
        fieldName: "currencyContract",
        displayName: "Curr",
        width: 60,
      },
      {
        fieldName: "percentagePartner",
        displayName: "Part.%",
        width: 70,
      },
      {
        fieldName: "invoicePartner",
        displayName: "Fact",
        width: 80,
      },
      {
        fieldName: "setup",
        displayName: "Setup",
        width: 60,
      },
      {
        fieldName: "deposit",
        displayName: "MAX_Y",
        width: 70,
      },
      {
        fieldName: "status",
        displayName: "Status",
        width: 70,
      },
      {
        fieldName: "created",
        displayName: "Created",
        width: 80,
      },
      {
        fieldName: "updated",
        displayName: "Updated",
        width: 80,
      },
      {
        fieldName: "start",
        displayName: "Start",
        width: 80,
      },
      {
        fieldName: "end",
        displayName: "End",
        width: 80,
      },
    ],
    form: [
      {
        fieldName: "propertyId",
        widget: "hidden",
      },
      {
        fieldName: "property",
        displayName: "Property",
        widget: "autoComplete",
        options: [],
        order: 20,
      },
      {
        fieldName: "invoice",
        displayName: "Cliente",
        widget: "autoComplete",
        options: [],
        className: "tickerInput",
        order: 30,
      },
      {
        fieldName: "serviceId",
        displayName: "Service",
        widget: "selector",
        defaultValue: "1",
        optionDisplay: {},
        order: 40,
      },
      {
        fieldName: "ruleId",
        displayName: "$Criteria",
        widget: "selector",
        defaultValue: "1",
        optionDisplay: {},
        order: 60,
      },
      {
        fieldName: "value",
        displayName: "$Value",
        widget: "input",
        defaultValue: 0,
        required: true,
        order: 80,
      },
      {
        fieldName: "minValue",
        displayName: "$Mínimo Mes",
        widget: "input",
        defaultValue: 0,
        required: true,
        order: 90,
      },
      {
        fieldName: "net",
        displayName: "$Neto",
        widget: "input",
        defaultValue: 1,
        required: true,
        order: 100,
      },
      {
        fieldName: "units",
        displayName: "$Units",
        widget: "input",
        required: true,
        order: 110,
      },
      {
        fieldName: "discount",
        displayName: "Descuento %",
        widget: "input",
        defaultValue: 0,
        order: 120,
      },
      {
        fieldName: "currencyContract",
        displayName: "Currency",
        widget: "selector",
        defaultValue: 0,
        optionDisplay: {
          EUR: {
            label: "EUR",
          },
          USD: {
            label: "USD",
          },
          COP: {
            label: "COP",
          },
        },
        order: 140,
      },
      {
        fieldName: "percentagePartner",
        displayName: "Partner %",
        widget: "input",
        defaultValue: 0,
        required: true,
        order: 150,
      },
      {
        fieldName: "invoicePartner",
        displayName: "Fact",
        widget: "selector",
        defaultValue: 0,
        optionDisplay: {
          [INVOICE_TYPE.DIRECT]: {
            label: "Directo",
          },
          [INVOICE_TYPE.PARTNER]: {
            label: "Partner",
          },
        },
        order: 160,
      },
      {
        fieldName: "setup",
        displayName: "Setup",
        widget: "input",
        defaultValue: 0,
        required: true,
        order: 170,
      },
      {
        fieldName: "deposit",
        displayName: "MAX_Y",
        widget: "input",
        defaultValue: 0,
        required: true,
        order: 180,
      },
      {
        fieldName: "start",
        displayName: "Start",
        widget: "datepicker",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Enter a date",
        isRange: false,
        startField: "start",
        endField: "end",
        selectsStart: true,
        order: 190,
      },
      {
        fieldName: "end",
        displayName: "End",
        widget: "datepicker",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Enter a date",
        isRange: false,
        startField: "start",
        endField: "end",
        selectsEnd: true,
        order: 200,
      },
    ],
  },
  validation: {
    property: autocompleteValidator,
    invoice: autocompleteValidator,
    payable: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    value: {
      type: "Number",
      constraints: {
        numericality: {},
        presence: {
          allowEmpty: false,
        },
      },
    },
    minValue: {
      type: "Number",
      constraints: {
        numericality: {},
      },
    },
    net: {
      type: "Number",
      constraints: {
        numericality: {},
        presence: {
          allowEmpty: false,
        },
      },
    },
    units: {
      type: "Number",
      constraints: {
        numericality: {},
        presence: {
          allowEmpty: false,
        },
      },
    },
    discount: {
      type: "Number",
      constraints: {
        numericality: {
          greaterThanOrEqualTo: 0,
          lessThanOrEqualTo: 100,
          message: <div>El valor debe estar entre 0 y 100</div>,
        },
      },
    },
    percentagePartner: {
      type: "Number",
      constraints: {
        presence: {
          allowEmpty: false,
        },
        numericality: {
          greaterThanOrEqualTo: 0,
          lessThanOrEqualTo: 100,
          message: <div>El valor debe estar entre 0 y 100</div>,
        },
      },
    },
    setup: {
      type: "Number",
      constraints: {
        numericality: {},
      },
    },
    deposit: {
      type: "Number",
      constraints: {
        numericality: {},
        presence: {
          allowEmpty: false,
        },
      },
    },
    start: {
      type: "Date",
      constraints: {
        compare: {
          logic: "isLesser",
          than: ["end"],
          message: "^El inicio debe ser menor que el final",
          valueType: "date",
        },
      },
      defaultValue: 0,
      relatedFields: [RESTRICTION_TYPE.OPEN_TRAVEL_END_DATE],
    },
    end: {
      type: "Date",
      constraints: {
        compare: {
          logic: "isGreater",
          than: ["start"],
          message: "^El final debe ser menor que el inicio",
          valueType: "date",
        },
      },
      defaultValue: 0,
      relatedFields: [RESTRICTION_TYPE.OPEN_TRAVEL_END_DATE],
    },
  },
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });
